/* @ngInject */
const saleButtons = (
  icons,
  saleGo,
  saleAsk
) => {
  const self = {}

  self.search = {
    icon: icons.search,
    action: saleGo.details,
    display: (_nature) => _nature === 'tables',
  }
  self.edit = {
    icon: icons.edit,
    action: saleGo.edit,
    display: (_nature) => true,
  }
  self.delete = {
    icon: icons.delete,
    action: saleAsk.delete,
    display: (_nature) => _nature === 'action',
    class: () => 'retour',
  }
  self.updateAllAxletrees = {
    icon: 'train',
    action: saleAsk.updateAllAxletrees,
    display: (_nature) => _nature === 'action',
  }

  return self
}
export default saleButtons



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/sale/resources/buttons.resource.js